module.exports = __webpack_public_path__ + "img/Magnuss71.42119da2.jpg";